<template>
  <div>
    <div
      v-if="schema.subtitle"
      class="subtitle flex flex-align-center mt-0" >
      <svg
        v-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string' && schema.subtitlePrefixIcon.endsWith('.svg')"
        class="mr-1 flex-start-image"
        :data-src="schema.subtitlePrefixIcon"
        fill="currentColor"
        width="10"
        height="10" />
      <img
        v-else-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string'"
        :src="schema.subtitlePrefixIcon"
        style="width: 10px; height: 10px;"
        class="mr-1 flex-start-image"
      >
      <SBIcon
        v-else-if="!schema.noSubtitlePrefixIcon"
        class="mr-1"
        :icon="SBIconList.INFO"
        :color="SBColors.greyLight"
        :size="10" />
      <span>{{ schema.subtitle }}</span>
    </div>
    <div
      v-for="(question, index) in questions"
      :key="index"
      class="flex flex-align-center" >
      <div
        class="greedy additional-question flex flex-align-center show-hand"
        @click="editQuestions(index)" >
        <span class="ellipsis content greedy">Ask if a contact reply contains {{ question.text | firstLowercase }}</span>
        <SBIcon
          class="ml-2 rotate-270"
          :icon="SBIconList.DOWN_ARROW"
          :color="SBColors.greyPrimary"
          :size="12" />
      </div>
      <SBIcon
        class=""
        style="margin-left: 12px; margin-right: 3px;"
        :icon="SBIconList.CLOSE_THIN"
        :color="SBColors.greyPrimary"
        :hover-icon-color="SBColors.blackPrimary"
        :size="10"
        pointer
        @click="removeAdditionalQuestion(index)" />
    </div>
    <div
      v-if="questions.length < schema.maxQuestions"
      class="add-more-question"
      @click="addNewquestion">
      <span class="flex flex-align-center">
        <img
          v-if="schema.addQuestionIcon && typeof schema.addQuestionIcon === 'string'"
          :src="schema.addQuestionIcon"
          style="width: 10px; height: 10px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="schema.addQuestionIcon"
          class="mr-2"
          :icon="schema.addQuestionIcon"
          :color="SBColors.bluePrimary"
          :size="8" />
        <span>{{ schema.addQuestionText }}</span>
      </span>
    </div>

    <QuestionModal
      ref="questionModalRef"
      @save="addAdditionalQuestion" />
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import { whatsappFormatMessage } from '@/helpers/stringHelpers';
import QuestionModal from './QuestionModal';

export default {
  name: 'QuestionsListModalWrapper',
  components: {
    SBIcon,
    QuestionModal,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      questions: [],
      returnData: [],
      btnSchema: {
        noAddButton: false,
        minButtons: 0,
        maxButtons: 3,
        addButtonIcon: SBIconList.PLUS,
        addButtonText: 'Add Button',
        enter: 'add',
        returnKey: 'buttons',
        placeholder: 'Button text',
        value: [
          // { title: 'Button 1' },
          // { title: 'Button 2' },
          // { title: 'Button 3' },
        ],
      },
      SBColors,
      SBIconList,
    };
  },
  computed: {
    warningValidators() {
      return this.schema.warningValidators ? this.schema.warningValidators.split(',') : [];
    },
  },
  watch: {
    questions: {
      handler() {
        this.$nextTick(() => {
          this.returnData = this.questions.map(question => ({
            label: question.text,
            questions: question.questions.map(question => ({
              text: whatsappFormatMessage(question.text).trim(),
              buttons: question.buttons ? question.buttons.value : [],
            })),
          }));
          this.emitData();
        });
      },
      deep: true,
    },
  },
  mounted() {
    if (this.schema.value) {
      this.schema.value.forEach((question) => {
        this.questions.push({ text: question.label, rawInput: null, questions: question.questions.map(q => ({ text: q.text, buttons: { value: q.buttons } })) });
      });
    }
    if (this.questions.length < this.schema.minQuestions) {
      for (let i = this.questions.length; i < this.schema.minQuestions; i += 1) {
        this.questions.push({ textValue: null, rawInput: null });
      }
    }
    setTimeout(() => {
      this.emitData(true);
    //   if (this.schema.value) {
    //     this.$refs.buttonsObserver.validate();
    //   }
    }, 0);
  },
  methods: {
    addAdditionalQuestion(additionalQuestion) {
      if (additionalQuestion.editMode) {
        this.$set(this.questions, additionalQuestion.editIndex, { text: additionalQuestion.value.replyContains.data.value, questions: additionalQuestion.value.questions.data.value });
        // this.questions[additionalQuestion.editIndex] = { text: additionalQuestion.value.replyContains.data.value, questions: additionalQuestion.value.questions.data.value };
      } else {
        this.questions.push({ text: additionalQuestion.value.replyContains.data.value, questions: additionalQuestion.value.questions.data.value });
      }
    },
    removeAdditionalQuestion(index) {
      this.questions.splice(index, 1);
    },
    editQuestions(index) {
      this.$refs.questionModalRef.show(this.returnData[index], index);
    },
    // textValueSync(textValue, index) {
    //   this.questions[index].textValue = textValue;
    // },
    // rawInputSync(rawInput, index) {
    //   const targetProviderRef = `textareaProvider-${index}`;
    //   this.questions[index].rawInput = rawInput;
    //   this.$refs[targetProviderRef][0].syncValue(rawInput);
    //   setTimeout(() => {
    //     this.$refs.questionObserver.validate();
    //   }, 0);
    // },
    addNewquestion() {
      this.$refs.questionModalRef.show({});
    },
    removeOption(index) {
      this.questions.splice(index, 1);
      setTimeout(() => {
        this.emitData();
      }, 0);
    },
    /** TODO this method(any some others) could be a part of a mixin for schema components. */
    // onlyWarnings() {
    //   const fields = Object.values(this.$refs.questionObserver.fields).map(field => Object.keys(field.failedRules)).flat(Infinity);
    //   const someTest = fields.length ? !fields.some(failed => !this.warningValidators.includes(failed)) : false; // if there are no fields, return false because it means the field is validated silently and no failedRules are being recorded
    //   return someTest;
    // },
    emitData(reset = false) {
      this.$emit('input', {
        valid: true,
        name: this.schema.returnKey || '',
        data: {
          value: this.returnData,
          date: new Date(),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-start-image {
  top: 1px;
  position: relative;
}

.question-header {
  // text-transform: uppercase;
  margin: 8px 0;
  font-size: 11px;
  font-weight: 500;
  color: $blackUltralight;

  &:after {
    content: '';
    height: 1px;
    border-bottom: 1px dashed $greyBorder;
    flex-grow: 2;
  }
}

.question-fields {
  .form-group {
    &.has-subtitle {
      margin-bottom: 0 !important;
    }
  }
}

.add-more-question {
  // display: inline-block;
  color: $bluePrimary;
  padding: 0 0 0 0;
  margin-top: 8px;

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    ::v-deep .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }

  &.disabled {
    pointer-events: none;
    color: $greyLight;

    ::v-deep .icon.mask {
      background-color: $greyLight !important;
    }
  }
}

.option {
  .option-item {
    margin-bottom: 10px;
  }

  .delete {
    // margin-right: 0 !important;
    margin-top: 12px;
    cursor: pointer;
  }

  &:hover {
    .delete {
      display: flex;
    }
  }
}

.error * {
  font-size: 12px !important;
  line-height: 1 !important;
}

.additional-question {
  margin: 8px 0;
  padding: 9px 12px;
  border-radius: 10px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px $greyBorder;
  background-color: $white;
  max-height: 32px;
  max-width: 100%;
  min-width: 0px;

  .content {
    font-size: 14px;
    font-weight: normal;
    color: $blackPrimary;
  }

  &:hover {
    ::v-deep .sb-icon .icon.mask {
      background-color: $blackPrimary !important;
    }
  }
}
</style>
